import { render, staticRenderFns } from "./provedor.vue?vue&type=template&id=6d2c6a3a&"
import script from "./provedor.vue?vue&type=script&lang=js&"
export * from "./provedor.vue?vue&type=script&lang=js&"
import style0 from "./provedor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports